import React from 'react';
import { useTranslation } from 'react-i18next';
import ExternalMessageModal from './external-message-modal';

interface Props {
  onClose: () => void;
}

export default function UserVerificationFailModal({ onClose }: Props) {
  const { t } = useTranslation();

  return (
    <ExternalMessageModal
      name={'failed_to_verify_user'}
      message={t('components.modals.failed_to_verify_user.message')}
      onClose={onClose}
    />
  );
}
